const { hostname } = window.location;

function getEnvVars() {
  const appEnv = process.env.REACT_APP_APP_ENV;
  if (hostname === 'console.ace.online' || appEnv === 'prod') {
    return buildProdEnvVars();
  }
  if (hostname === 'console-pre-prod.ace.online' || appEnv === 'pre-prod') {
    return buildPreProdEnvVars();
  }
  if (hostname === 'console-staging.ace.online' || appEnv === 'staging') {
    return buildStagingEnvVars();
  }
  if (hostname === 'console-test.ace.online' || appEnv === 'test') {
    return buildTestEnvVars();
  }
  if (hostname === 'console-dev.ace.online' || appEnv === 'dev') {
    return buildDevEnvVars();
  }
  return buildLocalEnvVars();
}

function buildProdEnvVars() {
  return {
    //TODO: make sure the production value is 'prod' or 'production'
    ENV: 'prod',

    // Banner Update
    s3BucketWebsiteBanners: 'ace-online-banner-bucket',
    s3BannerPath: 'Prod-Mobilebanner',
    remoteConfigBannerKey: 'appStoreBanner',
    remoteConfigFunctionUrl: 'https://updateremoteconfig-tsy7w2pxjq-uc.a.run.app',

    rsaPublicKey:
      'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCV0OeWTL5k1PdtC0YBlXLsoqChOvrI3X4A5/pvmmQGL+KkIPHbzKFy3TWrwTuyn9ghEz2JHrjkdCGsCnlLFm1XQp7TRrR7xkIA6FmXfsc+eaIfBJh0sj/Onsy9v0aqUdH6evoRbb/gWqJGYXRRcPSKIZOEInGvUpQLfRSPy0kqhQIDAQAB',
    hmacSecretKey: 'U2FsdGVkX19gPR8ll3tbuvInZz1lt4MRe+7AJDU5IirJz7dmHKMObd3gQ5ULhBc6',
    s3BucketFileExplore: 'deep-learn-vod-source-1pgk1xt548iii',
    s3BucketPublisher: 'deep-learn-internal-resources',
    s3BucketPreviewVideos: 'deep-learn-vod-source-1pgk1xt548iii',
    s3BucketLegal: 'deep-learn-internal-resources',
    s3BucketInstructor: 'deep-learn-internal-resources',
    s3BucketThumbnail: 'deep-learn-vod-destination-1lpke2l3cwme9',
    s3BucketTestimonial: 'deep-learn-internal-resources',
    s3BucketSyllabus: 'deep-learn-internal-resources',
    s3BucketStoreIcon: 'deep-learn-internal-resources',
    s3BucketQuestionPaper: 'deep-learn-internal-resources',
    s3BucketCatalogueImage: 'deep-learn-internal-resources',
    s3BucketLiveCLassResources: 'deep-learn-internal-resources',
    s3BucketTestSchedule: 'deep-learn-internal-resources',
    s3BucketFeatureIcon: 'deep-learn-internal-resources',
    s3BucketPreviewVideoThumbnail: 'deep-learn-internal-resources',

    s3PathLiveClassNotes: 'live-classes/notes/',
    s3PathLiveClassAssignments: 'live-classes/assignments/',
    s3PathLiveClassPracticeTests: 'live-classes/practice-test/',
    s3PathLiveClassThumbnails: 'live-classes/thumbnails/{uuid-filename}',
    s3PathLiveClassThumbnailForStaticList: 'live-classes/thumbnails/static-background/',

    s3PathImage: '[module]/images/',
    s3PathResource: '[module]/resources/',
    s3PathPreviewVideos: 'preview-videos/[catalogueId]/',
    s3PathLegalFile: 'terms_and_conditions/{uuid-filename}',
    s3PathInstructorImage: 'instructors/images/{uuid-filename}',
    s3PathInstructorResume: 'instructors/resumes/{uuid-filename}',
    s3PathTestimonialImage: 'store-listing/testimonials/{uuid-filename}',
    s3PathThumbnail: 'preview-videos/{catalogueId}/{videoId}/thumbnail/',
    s3PathSyllabus: 'catalogues/syllabus/{uuid-filename}',
    s3PathStoreIcon: 'catalogues/store-icon/{uuid-filename}',
    s3PathStoreImage: 'catalogues/store-image/{uuid-filename}',
    s3PathQuestionPaper: 'catalogues/question-paper/{uuid-filename}',
    s3PathCatalogueImage: 'catalogues/images/{uuid-filename}',
    s3PathTestSchedule: 'catalogues/testSchedule/{uuid-filename}',
    s3PathFeatureIcon: 'programs/icons/{uuid-filename}',
    s3PathPreviewVideoThumbnailList: 'preview-videos/thumbnails/',
    s3PathPreviewVideoThumbnail: 'preview-videos/thumbnails/{uuid-filename}',
    s3PathPreviewVideoThumbnailForStaticList: 'preview-videos/thumbnails/static-background/',
    s3PathPreviewVideoThumbnailForStatic:
      'preview-videos/thumbnails/static-background/{uuid-filename}',
    s3PathExamSyllabus: 'programs/exam-syllabus/{uuid-filename}',
    s3MaxKeys: 50,
    // Transcoding
    transcodingEnvironment: 'production',
    transcodingSourceS3: 'deep-learn-vod-source-1pgk1xt548iii',
    transcodingDestinationS3: 'deep-learn-vod-destination-1lpke2l3cwme9',

    // s3PathDynamic : "image/[path]/folder"
    cloudFrontUrlCatalogueResource: 'https://media-ir.ace.online',
    s3ResourceUrl: 'https://{bucketName}.s3.ap-south-1.amazonaws.com/{path}',

    cloudFrontUrl: 'https://media-ir.ace.online',
    previewVideoCloudfrontUrl: 'https://vod.ace.online',
    previewVideoHlsUrl: '{cloudFrontUrl}/preview-videos/{catalogueId}/{videoId}/index.m3u8',
    previewVideodashUrl: '{cloudFrontUrl}/preview-videos/{catalogueId}/{videoId}/manifest.mpd',

    cloudFrontUrlTnc: 'https://media-ir.ace.online',
    tncFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlInstructor: 'https://media-ir.ace.online',
    InstructorImageFileUrl: '{cloudFrontUrl}/{file-path}',
    InstructorResumeFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlTestimonial: 'https://media-ir.ace.online',
    TestimonialFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlThumbnail: 'https://d3ble58c9xsklv.cloudfront.net',
    thumbnailFolderUrl: '{cloudFrontUrl}/transcoding_version_3/preview-videos/{videoId}/thumbnails',

    cloudFrounUrlSyllabus: 'https://media-ir.ace.online',
    syllabusFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlStoreIcon: 'https://media-ir.ace.online',
    storeIconFileUrl: '{cloudFrontUrl}/{file-path}',
    testScheduleFileUrl: '{cloudFrontUrl}/{file-path}',
    featureIconFileUrl: '{cloudFrontUrl}/{file-path}',
    previewVideoThumbnailFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlQuestionPaper: 'https://media-ir.ace.online',
    questionPaperFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlCatalogueImage: 'https://media-ir.ace.online',
    catalogueImageFileUrl: '{cloudFrontUrl}/{file-path}',
    /// Bulk upload students sample resource link
    bulkUploadStudentXlxSampleFileLink:
      'https://media-ir.ace.online/live-classes/bulk_upload_sample_template.xlsx',

    cloudFrontUrlScholarshipDocument: 'https://media-sr.ace.online',
    aceProxyUrl: 'https://proxy.ace.online',
  };
}

function buildStagingEnvVars() {
  return {
    ENV: 'staging',

    // Banner Update
    s3BucketWebsiteBanners: 'ace-online-banner-bucket',
    s3BannerPath: 'Stage-Mobilebanner',
    remoteConfigBannerKey: 'stageAppStoreBanner',
    remoteConfigFunctionUrl: 'https://updateremoteconfig-tsy7w2pxjq-uc.a.run.app',

    rsaPublicKey:
      'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCA33d/ObvH5A+UkxrtoAI5MmC4R0saRRomrbnVPZj2oDSeCUgQL3WKDb/xxwbRVu+ZIcbLBWal3aoLH9W6TKTHbZY6czkTHaT1RzeWX7nWwiwuZOVIc7gdH6ty+u+p00XTI0Rnme7dNlRF/8f92JQ045sqqSxb78pOYzCQZFxdhQIDAQAB',
    hmacSecretKey: 'U2FsdGVkX19qjUrmm1S3Co/5XxzAh7bVIl4wPeSzIKY=',
    s3BucketFileExplore: 'deep-learn-vod-test-source-1l5ur8c463vtl',
    s3BucketPublisher: 'deep-learn-internal-resources-test',
    s3BucketPreviewVideos: 'deep-learn-vod-test-source-1l5ur8c463vtl',
    s3BucketLegal: 'deep-learn-internal-resources-test',
    s3BucketInstructor: 'deep-learn-internal-resources-test',
    s3BucketThumbnail: 'deep-learn-vod-test-destination-1k6b102sisn5o',
    s3BucketTestimonial: 'deep-learn-internal-resources-test',
    s3BucketSyllabus: 'deep-learn-internal-resources-test',
    s3BucketStoreIcon: 'deep-learn-internal-resources-test',
    s3BucketQuestionPaper: 'deep-learn-internal-resources-test',
    s3BucketCatalogueImage: 'deep-learn-internal-resources-test',
    s3BucketLiveCLassResources: 'deep-learn-internal-resources-test',
    s3BucketTestSchedule: 'deep-learn-internal-resources-test',
    s3BucketFeatureIcon: 'deep-learn-internal-resources-test',
    s3BucketPreviewVideoThumbnail: 'deep-learn-internal-resources-test',

    s3PathLiveClassNotes: 'live-classes/notes/',
    s3PathLiveClassAssignments: 'live-classes/assignments/',
    s3PathLiveClassPracticeTests: 'live-classes/practice-test/',
    s3PathLiveClassThumbnails: 'live-classes/thumbnails/{uuid-filename}',
    s3PathLiveClassThumbnailForStaticList: 'live-classes/thumbnails/static-background/',

    s3PathImage: '[module]/images/',
    s3PathResource: '[module]/resources/',
    s3PathPreviewVideos: 'preview-videos/[catalogueId]/',
    s3PathLegalFile: 'terms_and_conditions/{uuid-filename}',
    s3PathInstructorImage: 'instructors/images/{uuid-filename}',
    s3PathInstructorResume: 'instructors/resumes/{uuid-filename}',
    s3PathTestimonialImage: 'store-listing/testimonials/{uuid-filename}',
    s3PathThumbnail: 'preview-videos/{catalogueId}/{videoId}/thumbnail/',
    s3PathSyllabus: 'catalogues/syllabus/{uuid-filename}',
    s3PathStoreIcon: 'catalogues/store-icon/{uuid-filename}',
    s3PathStoreImage: 'catalogues/store-image/{uuid-filename}',
    s3PathQuestionPaper: 'catalogues/question-paper/{uuid-filename}',
    s3PathCatalogueImage: 'catalogues/images/{uuid-filename}',
    s3PathTestSchedule: 'catalogues/testSchedule/{uuid-filename}',
    s3PathFeatureIcon: 'programs/icons/{uuid-filename}',
    s3PathPreviewVideoThumbnailList: 'preview-videos/thumbnails/',
    s3PathPreviewVideoThumbnail: 'preview-videos/thumbnails/{uuid-filename}',
    s3PathPreviewVideoThumbnailForStaticList: 'preview-videos/thumbnails/static-background/',
    s3PathPreviewVideoThumbnailForStatic:
      'preview-videos/thumbnails/static-background/{uuid-filename}',
    s3PathExamSyllabus: 'programs/exam-syllabus/{uuid-filename}',
    s3MaxKeys: 50,
    // Transcoding
    transcodingEnvironment: 'staging',
    transcodingSourceS3: 'deep-learn-vod-test-source-1l5ur8c463vtl',
    transcodingDestinationS3: 'deep-learn-vod-test-destination-1k6b102sisn5o',

    // s3PathDynamic : "image/[path]/folder"
    cloudFrontUrlCatalogueResource: 'https://media-ir-test.ace.online',
    s3ResourceUrl: 'https://{bucketName}.s3.ap-south-1.amazonaws.com/{path}',

    cloudFrontUrl: 'https://media-ir-test.ace.online',
    previewVideoCloudfrontUrl: 'https://vod.ace.online',
    previewVideoHlsUrl: '{cloudFrontUrl}/preview-videos/{catalogueId}/{videoId}/index.m3u8',
    previewVideodashUrl: '{cloudFrontUrl}/preview-videos/{catalogueId}/{videoId}/manifest.mpd',

    cloudFrontUrlTnc: 'https://media-ir-test.ace.online',
    tncFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlInstructor: 'https://media-ir-test.ace.online',
    InstructorImageFileUrl: '{cloudFrontUrl}/{file-path}',
    InstructorResumeFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlTestimonial: 'https://media-ir-test.ace.online',
    TestimonialFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlThumbnail: 'https://d2gd7uae3xw47.cloudfront.net',
    thumbnailFolderUrl: '{cloudFrontUrl}/transcoding_version_3/preview-videos/{videoId}/thumbnails',

    cloudFrounUrlSyllabus: 'https://media-ir-test.ace.online',
    syllabusFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlStoreIcon: 'https://media-ir-test.ace.online',
    storeIconFileUrl: '{cloudFrontUrl}/{file-path}',
    testScheduleFileUrl: '{cloudFrontUrl}/{file-path}',
    featureIconFileUrl: '{cloudFrontUrl}/{file-path}',
    previewVideoThumbnailFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlQuestionPaper: 'https://media-ir-test.ace.online',
    questionPaperFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlCatalogueImage: 'https://media-ir-test.ace.online',
    catalogueImageFileUrl: '{cloudFrontUrl}/{file-path}',
    /// Bulk upload students sample resource link
    bulkUploadStudentXlxSampleFileLink:
      'https://media-ir-test.ace.online/live-classes/bulk_upload_sample_template.xlsx',
    cloudFrontUrlScholarshipDocument: 'https://media-sr-test.ace.online',
    aceProxyUrl: 'https://staging-proxy.ace.online',
  };
}
function buildPreProdEnvVars() {
  return {
    //TODO: make sure the production value is 'prod' or 'production'
    ENV: 'preProd',

    // Banner Update
    s3BucketWebsiteBanners: 'ace-online-banner-bucket',
    s3BannerPath: 'Prod-Mobilebanner',
    remoteConfigBannerKey: 'appStoreBanner',
    remoteConfigFunctionUrl: 'https://updateremoteconfig-tsy7w2pxjq-uc.a.run.app',

    rsaPublicKey:
      'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCA33d/ObvH5A+UkxrtoAI5MmC4R0saRRomrbnVPZj2oDSeCUgQL3WKDb/xxwbRVu+ZIcbLBWal3aoLH9W6TKTHbZY6czkTHaT1RzeWX7nWwiwuZOVIc7gdH6ty+u+p00XTI0Rnme7dNlRF/8f92JQ045sqqSxb78pOYzCQZFxdhQIDAQAB',
    hmacSecretKey: 'U2FsdGVkX19qjUrmm1S3Co/5XxzAh7bVIl4wPeSzIKY=',
    s3BucketFileExplore: 'deep-learn-vod-source-1pgk1xt548iii',
    s3BucketPublisher: 'deep-learn-internal-resources',
    s3BucketPreviewVideos: 'deep-learn-vod-source-1pgk1xt548iii',
    s3BucketLegal: 'deep-learn-internal-resources',
    s3BucketInstructor: 'deep-learn-internal-resources',
    s3BucketThumbnail: 'deep-learn-vod-destination-1lpke2l3cwme9',
    s3BucketTestimonial: 'deep-learn-internal-resources',
    s3BucketSyllabus: 'deep-learn-internal-resources',
    s3BucketStoreIcon: 'deep-learn-internal-resources',
    s3BucketQuestionPaper: 'deep-learn-internal-resources',
    s3BucketCatalogueImage: 'deep-learn-internal-resources',
    s3BucketLiveCLassResources: 'deep-learn-internal-resources',
    s3BucketTestSchedule: 'deep-learn-internal-resources',
    s3BucketFeatureIcon: 'deep-learn-internal-resources',
    s3BucketPreviewVideoThumbnail: 'deep-learn-internal-resources',

    s3PathLiveClassNotes: 'live-classes/notes/',
    s3PathLiveClassAssignments: 'live-classes/assignments/',
    s3PathLiveClassPracticeTests: 'live-classes/practice-test/',
    s3PathLiveClassThumbnails: 'live-classes/thumbnails/{uuid-filename}',
    s3PathLiveClassThumbnailForStaticList: 'live-classes/thumbnails/static-background/',

    s3PathImage: '[module]/images/',
    s3PathResource: '[module]/resources/',
    s3PathPreviewVideos: 'preview-videos/[catalogueId]/',
    s3PathLegalFile: 'terms_and_conditions/{uuid-filename}',
    s3PathInstructorImage: 'instructors/images/{uuid-filename}',
    s3PathInstructorResume: 'instructors/resumes/{uuid-filename}',
    s3PathTestimonialImage: 'store-listing/testimonials/{uuid-filename}',
    s3PathThumbnail: 'preview-videos/{catalogueId}/{videoId}/thumbnail/',
    s3PathSyllabus: 'catalogues/syllabus/{uuid-filename}',
    s3PathStoreIcon: 'catalogues/store-icon/{uuid-filename}',
    s3PathStoreImage: 'catalogues/store-image/{uuid-filename}',
    s3PathQuestionPaper: 'catalogues/question-paper/{uuid-filename}',
    s3PathCatalogueImage: 'catalogues/images/{uuid-filename}',
    s3PathTestSchedule: 'catalogues/testSchedule/{uuid-filename}',
    s3PathFeatureIcon: 'programs/icons/{uuid-filename}',
    s3PathPreviewVideoThumbnailList: 'preview-videos/thumbnails/',
    s3PathPreviewVideoThumbnail: 'preview-videos/thumbnails/{uuid-filename}',
    s3PathPreviewVideoThumbnailForStaticList: 'preview-videos/thumbnails/static-background/',
    s3PathPreviewVideoThumbnailForStatic:
      'preview-videos/thumbnails/static-background/{uuid-filename}',
    s3PathExamSyllabus: 'programs/exam-syllabus/{uuid-filename}',
    s3MaxKeys: 50,
    // Transcoding
    transcodingEnvironment: 'production',
    transcodingSourceS3: 'deep-learn-vod-source-1pgk1xt548iii',
    transcodingDestinationS3: 'deep-learn-vod-destination-1lpke2l3cwme9',

    // s3PathDynamic : "image/[path]/folder"
    cloudFrontUrlCatalogueResource: 'https://media-ir.ace.online',
    s3ResourceUrl: 'https://{bucketName}.s3.ap-south-1.amazonaws.com/{path}',

    cloudFrontUrl: 'https://media-ir.ace.online',
    previewVideoCloudfrontUrl: 'https://vod.ace.online',
    previewVideoHlsUrl: '{cloudFrontUrl}/preview-videos/{catalogueId}/{videoId}/index.m3u8',
    previewVideodashUrl: '{cloudFrontUrl}/preview-videos/{catalogueId}/{videoId}/manifest.mpd',

    cloudFrontUrlTnc: 'https://media-ir.ace.online',
    tncFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlInstructor: 'https://media-ir.ace.online',
    InstructorImageFileUrl: '{cloudFrontUrl}/{file-path}',
    InstructorResumeFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlTestimonial: 'https://media-ir.ace.online',
    TestimonialFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlThumbnail: 'https://d3ble58c9xsklv.cloudfront.net',
    thumbnailFolderUrl: '{cloudFrontUrl}/transcoding_version_3/preview-videos/{videoId}/thumbnails',

    cloudFrounUrlSyllabus: 'https://media-ir.ace.online',
    syllabusFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlStoreIcon: 'https://media-ir.ace.online',
    storeIconFileUrl: '{cloudFrontUrl}/{file-path}',
    testScheduleFileUrl: '{cloudFrontUrl}/{file-path}',
    featureIconFileUrl: '{cloudFrontUrl}/{file-path}',
    previewVideoThumbnailFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlQuestionPaper: 'https://media-ir.ace.online',
    questionPaperFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlCatalogueImage: 'https://media-ir.ace.online',
    catalogueImageFileUrl: '{cloudFrontUrl}/{file-path}',
    /// Bulk upload students sample resource link
    bulkUploadStudentXlxSampleFileLink:
      'https://media-ir.ace.online/live-classes/bulk_upload_sample_template.xlsx',
    cloudFrontUrlScholarshipDocument: 'https://media-sr.ace.online',
    aceProxyUrl: 'https://proxy.ace.online',
  };
}
function buildTestEnvVars() {
  return {
    ENV: 'test',

    // Banner Update
    s3BucketWebsiteBanners: 'ace-online-banner-bucket',
    s3BannerPath: 'Mobilebanner',
    remoteConfigBannerKey: 'devAppStoreBanner',
    remoteConfigFunctionUrl: 'https://updateremoteconfig-tsy7w2pxjq-uc.a.run.app',

    rsaPublicKey:
      'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCA33d/ObvH5A+UkxrtoAI5MmC4R0saRRomrbnVPZj2oDSeCUgQL3WKDb/xxwbRVu+ZIcbLBWal3aoLH9W6TKTHbZY6czkTHaT1RzeWX7nWwiwuZOVIc7gdH6ty+u+p00XTI0Rnme7dNlRF/8f92JQ045sqqSxb78pOYzCQZFxdhQIDAQAB',
    hmacSecretKey: 'U2FsdGVkX19qjUrmm1S3Co/5XxzAh7bVIl4wPeSzIKY=',
    s3BucketFileExplore: 'deep-learn-vod-test-source-1l5ur8c463vtl',
    s3BucketPublisher: 'deep-learn-internal-resources-test',
    s3BucketPreviewVideos: 'deep-learn-vod-test-source-1l5ur8c463vtl',
    s3BucketLegal: 'deep-learn-internal-resources-test',
    s3BucketInstructor: 'deep-learn-internal-resources-test',
    s3BucketThumbnail: 'deep-learn-vod-test-destination-1k6b102sisn5o',
    s3BucketTestimonial: 'deep-learn-internal-resources-test',
    s3BucketSyllabus: 'deep-learn-internal-resources-test',
    s3BucketStoreIcon: 'deep-learn-internal-resources-test',
    s3BucketQuestionPaper: 'deep-learn-internal-resources-test',
    s3BucketCatalogueImage: 'deep-learn-internal-resources-test',
    s3BucketLiveCLassResources: 'deep-learn-internal-resources-test',
    s3BucketTestSchedule: 'deep-learn-internal-resources-test',
    s3BucketFeatureIcon: 'deep-learn-internal-resources-test',
    s3BucketPreviewVideoThumbnail: 'deep-learn-internal-resources-test',

    s3PathLiveClassNotes: 'live-classes/notes/',
    s3PathLiveClassAssignments: 'live-classes/assignments/',
    s3PathLiveClassPracticeTests: 'live-classes/practice-test/',
    s3PathLiveClassThumbnails: 'live-classes/thumbnails/{uuid-filename}',
    s3PathLiveClassThumbnailForStaticList: 'live-classes/thumbnails/static-background/',

    s3PathImage: '[module]/images/',
    s3PathResource: '[module]/resources/',
    s3PathPreviewVideos: 'preview-videos/[catalogueId]/',
    s3PathLegalFile: 'terms_and_conditions/{uuid-filename}',
    s3PathInstructorImage: 'instructors/images/{uuid-filename}',
    s3PathInstructorResume: 'instructors/resumes/{uuid-filename}',
    s3PathTestimonialImage: 'store-listing/testimonials/{uuid-filename}',
    s3PathThumbnail: 'preview-videos/{catalogueId}/{videoId}/thumbnail/',
    s3PathSyllabus: 'catalogues/syllabus/{uuid-filename}',
    s3PathStoreIcon: 'catalogues/store-icon/{uuid-filename}',
    s3PathStoreImage: 'catalogues/store-image/{uuid-filename}',
    s3PathQuestionPaper: 'catalogues/question-paper/{uuid-filename}',
    s3PathCatalogueImage: 'catalogues/images/{uuid-filename}',
    s3PathTestSchedule: 'catalogues/testSchedule/{uuid-filename}',
    s3PathFeatureIcon: 'programs/icons/{uuid-filename}',
    s3PathPreviewVideoThumbnailList: 'preview-videos/thumbnails/',
    s3PathPreviewVideoThumbnail: 'preview-videos/thumbnails/{uuid-filename}',
    s3PathPreviewVideoThumbnailForStaticList: 'preview-videos/thumbnails/static-background/',
    s3PathPreviewVideoThumbnailForStatic:
      'preview-videos/thumbnails/static-background/{uuid-filename}',
    s3PathExamSyllabus: 'programs/exam-syllabus/{uuid-filename}',
    s3MaxKeys: 50,
    // Transcoding
    transcodingEnvironment: 'test',
    transcodingSourceS3: 'deep-learn-vod-test-source-1l5ur8c463vtl',
    transcodingDestinationS3: 'deep-learn-vod-test-destination-1k6b102sisn5o',
    // s3PathDynamic : "image/[path]/folder"
    cloudFrontUrlCatalogueResource: 'https://media-ir-test.ace.online',
    s3ResourceUrl: 'https://{bucketName}.s3.ap-south-1.amazonaws.com/{path}',

    cloudFrontUrl: 'https://media-ir-test.ace.online',
    previewVideoCloudfrontUrl: 'https://vod.ace.online',
    previewVideoHlsUrl: '{cloudFrontUrl}/preview-videos/{catalogueId}/{videoId}/index.m3u8',
    previewVideodashUrl: '{cloudFrontUrl}/preview-videos/{catalogueId}/{videoId}/manifest.mpd',

    cloudFrontUrlTnc: 'https://media-ir-test.ace.online',
    tncFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlInstructor: 'https://media-ir-test.ace.online',
    InstructorImageFileUrl: '{cloudFrontUrl}/{file-path}',
    InstructorResumeFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlTestimonial: 'https://media-ir-test.ace.online',
    TestimonialFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlThumbnail: 'https://d2gd7uae3xw47.cloudfront.net',
    thumbnailFolderUrl: '{cloudFrontUrl}/transcoding_version_3/preview-videos/{videoId}/thumbnails',

    cloudFrounUrlSyllabus: 'https://media-ir-test.ace.online',
    syllabusFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlStoreIcon: 'https://media-ir-test.ace.online',
    storeIconFileUrl: '{cloudFrontUrl}/{file-path}',
    testScheduleFileUrl: '{cloudFrontUrl}/{file-path}',
    featureIconFileUrl: '{cloudFrontUrl}/{file-path}',
    previewVideoThumbnailFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlQuestionPaper: 'https://media-ir-test.ace.online',
    questionPaperFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlCatalogueImage: 'https://media-ir-test.ace.online',
    catalogueImageFileUrl: '{cloudFrontUrl}/{file-path}',
    /// Bulk upload students sample resource link
    bulkUploadStudentXlxSampleFileLink:
      'https://media-ir-test.ace.online/live-classes/bulk_upload_sample_template.xlsx',
    cloudFrontUrlScholarshipDocument: 'https://media-sr-test.ace.online',
    aceProxyUrl: 'https://test-proxy.ace.online',
  };
}

function buildLocalEnvVars() {
  return {
    ENV: 'test',

    // Banner Update
    s3BucketWebsiteBanners: 'ace-online-banner-bucket',
    s3BannerPath: 'Mobilebanner',
    remoteConfigBannerKey: 'devAppStoreBanner',
    remoteConfigFunctionUrl: 'https://updateremoteconfig-tsy7w2pxjq-uc.a.run.app',

    rsaPublicKey:
      'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCA33d/ObvH5A+UkxrtoAI5MmC4R0saRRomrbnVPZj2oDSeCUgQL3WKDb/xxwbRVu+ZIcbLBWal3aoLH9W6TKTHbZY6czkTHaT1RzeWX7nWwiwuZOVIc7gdH6ty+u+p00XTI0Rnme7dNlRF/8f92JQ045sqqSxb78pOYzCQZFxdhQIDAQAB',
    hmacSecretKey: 'U2FsdGVkX19qjUrmm1S3Co/5XxzAh7bVIl4wPeSzIKY=',
    s3BucketFileExplore: 'deep-learn-vod-test-source-1l5ur8c463vtl',
    s3BucketPublisher: 'deep-learn-internal-resources-test',
    s3BucketPreviewVideos: 'deep-learn-vod-test-source-1l5ur8c463vtl',
    s3BucketLegal: 'deep-learn-internal-resources-test',
    s3BucketInstructor: 'deep-learn-internal-resources-test',
    s3BucketThumbnail: 'deep-learn-vod-test-destination-1k6b102sisn5o',
    s3BucketTestimonial: 'deep-learn-internal-resources-test',
    s3BucketSyllabus: 'deep-learn-internal-resources-test',
    s3BucketStoreIcon: 'deep-learn-internal-resources-test',
    s3BucketQuestionPaper: 'deep-learn-internal-resources-test',
    s3BucketCatalogueImage: 'deep-learn-internal-resources-test',
    s3BucketLiveCLassResources: 'deep-learn-internal-resources-test',
    s3BucketTestSchedule: 'deep-learn-internal-resources-test',
    s3BucketFeatureIcon: 'deep-learn-internal-resources-test',
    s3BucketPreviewVideoThumbnail: 'deep-learn-internal-resources-test',

    s3PathLiveClassNotes: 'live-classes/notes/',
    s3PathLiveClassAssignments: 'live-classes/assignments/',
    s3PathLiveClassPracticeTests: 'live-classes/practice-test/',
    s3PathLiveClassThumbnails: 'live-classes/thumbnails/{uuid-filename}',
    s3PathLiveClassThumbnailForStaticList: 'live-classes/thumbnails/static-background/',

    s3PathImage: '[module]/images/',
    s3PathResource: '[module]/resources/',
    s3PathPreviewVideos: 'preview-videos/[catalogueId]/',
    s3PathLegalFile: 'terms_and_conditions/{uuid-filename}',
    s3PathInstructorImage: 'instructors/images/{uuid-filename}',
    s3PathInstructorResume: 'instructors/resumes/{uuid-filename}',
    s3PathTestimonialImage: 'store-listing/testimonials/{uuid-filename}',
    s3PathThumbnail: 'preview-videos/{catalogueId}/{videoId}/thumbnail/',
    s3PathSyllabus: 'catalogues/syllabus/{uuid-filename}',
    s3PathStoreIcon: 'catalogues/store-icon/{uuid-filename}',
    s3PathStoreImage: 'catalogues/store-image/{uuid-filename}',
    s3PathQuestionPaper: 'catalogues/question-paper/{uuid-filename}',
    s3PathCatalogueImage: 'catalogues/images/{uuid-filename}',
    s3PathTestSchedule: 'catalogues/testSchedule/{uuid-filename}',
    s3PathFeatureIcon: 'programs/icons/{uuid-filename}',
    s3PathPreviewVideoThumbnailList: 'preview-videos/thumbnails/',
    s3PathPreviewVideoThumbnail: 'preview-videos/thumbnails/{uuid-filename}',
    s3PathPreviewVideoThumbnailForStaticList: 'preview-videos/thumbnails/static-background/',
    s3PathPreviewVideoThumbnailForStatic:
      'preview-videos/thumbnails/static-background/{uuid-filename}',
    s3PathExamSyllabus: 'programs/exam-syllabus/{uuid-filename}',
    s3MaxKeys: 50,
    // Transcoding
    transcodingEnvironment: 'test',
    transcodingSourceS3: 'deep-learn-vod-test-source-1l5ur8c463vtl',
    transcodingDestinationS3: 'deep-learn-vod-test-destination-1k6b102sisn5o',

    cloudFrontUrlCatalogueResource: 'https://media-ir-test.ace.online',
    s3ResourceUrl: 'https://{bucketName}.s3.ap-south-1.amazonaws.com/{path}',

    cloudFrontUrl: 'https://media-ir-test.ace.online',
    previewVideoCloudfrontUrl: 'https://vod.ace.online',
    previewVideoHlsUrl: '{cloudFrontUrl}/preview-videos/{catalogueId}/{videoId}/index.m3u8',
    previewVideodashUrl: '{cloudFrontUrl}/preview-videos/{catalogueId}/{videoId}/manifest.mpd',

    cloudFrontUrlTnc: 'https://media-ir-test.ace.online',
    tncFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlInstructor: 'https://media-ir-test.ace.online',
    InstructorImageFileUrl: '{cloudFrontUrl}/{file-path}',
    InstructorResumeFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlTestimonial: 'https://media-ir-test.ace.online',
    TestimonialFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlThumbnail: 'https://d2gd7uae3xw47.cloudfront.net',
    thumbnailFolderUrl: '{cloudFrontUrl}/transcoding_version_3/preview-videos/{videoId}/thumbnails',

    cloudFrontUrlStoreIcon: 'https://media-ir-test.ace.online',
    syllabusFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrounUrlStoreIcon: 'https://media-ir-test.ace.online',
    storeIconFileUrl: '{cloudFrontUrl}/{file-path}',
    testScheduleFileUrl: '{cloudFrontUrl}/{file-path}',
    featureIconFileUrl: '{cloudFrontUrl}/{file-path}',
    previewVideoThumbnailFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlQuestionPaper: 'https://media-ir-test.ace.online',
    questionPaperFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlCatalogueImage: 'https://media-ir-test.ace.online',
    catalogueImageFileUrl: '{cloudFrontUrl}/{file-path}',
    /// Bulk upload students sample resource link
    bulkUploadStudentXlxSampleFileLink:
      'https://media-ir-test.ace.online/live-classes/bulk_upload_sample_template.xlsx',
    cloudFrontUrlScholarshipDocument: 'https://media-sr-test.ace.online',
    aceProxyUrl: 'https://test-proxy.ace.online',
  };
}

function buildDevEnvVars() {
  return {
    ENV: 'dev',

    // Banner Update
    s3BucketWebsiteBanners: 'ace-online-banner-bucket',
    s3BannerPath: 'Mobilebanner',
    remoteConfigBannerKey: 'devAppStoreBanner',
    remoteConfigFunctionUrl: 'https://updateremoteconfig-tsy7w2pxjq-uc.a.run.app',

    rsaPublicKey:
      'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCA33d/ObvH5A+UkxrtoAI5MmC4R0saRRomrbnVPZj2oDSeCUgQL3WKDb/xxwbRVu+ZIcbLBWal3aoLH9W6TKTHbZY6czkTHaT1RzeWX7nWwiwuZOVIc7gdH6ty+u+p00XTI0Rnme7dNlRF/8f92JQ045sqqSxb78pOYzCQZFxdhQIDAQAB',
    hmacSecretKey: 'U2FsdGVkX19qjUrmm1S3Co/5XxzAh7bVIl4wPeSzIKY=',
    s3BucketFileExplore: 'deep-learn-vod-test-source-1l5ur8c463vtl',
    s3BucketPublisher: 'deep-learn-internal-resources-test',
    s3BucketPreviewVideos: 'deep-learn-vod-test-source-1l5ur8c463vtl',
    s3BucketLegal: 'deep-learn-internal-resources-test',
    s3BucketInstructor: 'deep-learn-internal-resources-test',
    s3BucketThumbnail: 'deep-learn-vod-test-destination-1k6b102sisn5o',
    s3BucketTestimonial: 'deep-learn-internal-resources-test',
    s3BucketSyllabus: 'deep-learn-internal-resources-test',
    s3BucketStoreIcon: 'deep-learn-internal-resources-test',
    s3BucketQuestionPaper: 'deep-learn-internal-resources-test',
    s3BucketCatalogueImage: 'deep-learn-internal-resources-test',
    s3BucketLiveCLassResources: 'deep-learn-internal-resources-test',
    s3BucketTestSchedule: 'deep-learn-internal-resources-test',
    s3BucketFeatureIcon: 'deep-learn-internal-resources-test',
    s3BucketPreviewVideoThumbnail: 'deep-learn-internal-resources-test',

    s3PathLiveClassNotes: 'live-classes/notes/',
    s3PathLiveClassAssignments: 'live-classes/assignments/',
    s3PathLiveClassPracticeTests: 'live-classes/practice-test/',
    s3PathLiveClassThumbnails: 'live-classes/thumbnails/{uuid-filename}',
    s3PathLiveClassThumbnailForStaticList: 'live-classes/thumbnails/static-background/',

    s3PathImage: '[module]/images/',
    s3PathResource: '[module]/resources/',
    s3PathPreviewVideos: 'preview-videos/[catalogueId]/',
    s3PathLegalFile: 'terms_and_conditions/{uuid-filename}',
    s3PathInstructorImage: 'instructors/images/{uuid-filename}',
    s3PathInstructorResume: 'instructors/resumes/{uuid-filename}',
    s3PathTestimonialImage: 'store-listing/testimonials/{uuid-filename}',
    s3PathThumbnail: 'preview-videos/{catalogueId}/{videoId}/thumbnail/',
    s3PathSyllabus: 'catalogues/syllabus/{uuid-filename}',
    s3PathStoreIcon: 'catalogues/storeIcon/{uuid-filename}',
    s3PathStoreImage: 'catalogues/store-image/{uuid-filename}',
    s3PathTestSchedule: 'catalogues/testSchedule/{uuid-filename}',
    s3PathQuestionPaper: 'catalogues/question-paper/{uuid-filename}',
    s3PathCatalogueImage: 'catalogues/images/{uuid-filename}',
    s3PathFeatureIcon: 'programs/icons/{uuid-filename}',
    s3PathPreviewVideoThumbnailList: 'preview-videos/thumbnails/',
    s3PathPreviewVideoThumbnail: 'preview-videos/thumbnails/{uuid-filename}',
    s3PathPreviewVideoThumbnailForStaticList: 'preview-videos/thumbnails/static-background/',
    s3PathPreviewVideoThumbnailForStatic:
      'preview-videos/thumbnails/static-background/{uuid-filename}',
    s3PathExamSyllabus: 'programs/exam-syllabus/{uuid-filename}',
    s3MaxKeys: 50,
    // Transcoding
    transcodingEnvironment: 'development',
    transcodingSourceS3: 'deep-learn-vod-test-source-1l5ur8c463vtl',
    transcodingDestinationS3: 'deep-learn-vod-test-destination-1k6b102sisn5o',

    cloudFrontUrlCatalogueResource: 'https://media-ir-test.ace.online',
    s3ResourceUrl: 'https://{bucketName}.s3.ap-south-1.amazonaws.com/{path}',

    cloudFrontUrl: 'https://media-ir-test.ace.online',
    previewVideoCloudfrontUrl: 'https://vod.ace.online',
    previewVideoHlsUrl: '{cloudFrontUrl}/preview-videos/{catalogueId}/{videoId}/index.m3u8',
    previewVideodashUrl: '{cloudFrontUrl}/preview-videos/{catalogueId}/{videoId}/manifest.mpd',

    cloudFrontUrlTnc: 'https://media-ir-test.ace.online',
    tncFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlInstructor: 'https://media-ir-test.ace.online',
    InstructorImageFileUrl: '{cloudFrontUrl}/{file-path}',
    InstructorResumeFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlTestimonial: 'https://media-ir-test.ace.online',
    TestimonialFileUrl: '{cloudFrontUrl}/{file-path}',
    cloudFrontUrlThumbnail: 'https://d2gd7uae3xw47.cloudfront.net',
    thumbnailFolderUrl: '{cloudFrontUrl}/transcoding_version_3/preview-videos/{videoId}/thumbnails',

    cloudFrounUrlSyllabus: 'https://media-ir-test.ace.online',
    syllabusFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlStoreIcon: 'https://media-ir-test.ace.online',
    storeIconFileUrl: '{cloudFrontUrl}/{file-path}',
    testScheduleFileUrl: '{cloudFrontUrl}/{file-path}',
    featureIconFileUrl: '{cloudFrontUrl}/{file-path}',
    previewVideoThumbnailFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlQuestionPaper: 'https://media-ir-test.ace.online',
    questionPaperFileUrl: '{cloudFrontUrl}/{file-path}',

    cloudFrontUrlCatalogueImage: 'https://media-ir-test.ace.online',
    catalogueImageFileUrl: '{cloudFrontUrl}/{file-path}',
    /// Bulk upload students sample resource link
    bulkUploadStudentXlxSampleFileLink:
      'https://media-ir-test.ace.online/live-classes/bulk_upload_sample_template.xlsx',
    cloudFrontUrlScholarshipDocument: 'https://media-sr-test.ace.online',
    aceProxyUrl: 'https://dev-proxy.ace.online',
  };
}

export { getEnvVars };
